import { render } from "./g-window-view.vue?vue&type=template&id=04d79330&ts=true"
import script from "./g-window-view.vue?vue&type=script&lang=tsx"
export * from "./g-window-view.vue?vue&type=script&lang=tsx"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__